import { Pipe, PipeTransform } from '@angular/core';
import { FormHelper } from 'src/app/core/helpers/form.helper';
import { NullSafe } from 'src/app/core/types/null-safe.type';

@Pipe({
  name: 'contadorRichText',
})
export class ContadorRichTextPipe implements PipeTransform {
  transform(value: NullSafe<string>): string {
    return FormHelper.contadorRichText(value ?? '');
  }
}
